import { Component } from '@angular/core';
import { NonIPBoardSummaryComponent } from '../non-ip-board-summary.component';

@Component({
  selector: 'client-board-summary',
  templateUrl: './client-board-summary.component.html',
  styleUrls: ['./client-board-summary.component.scss']
})
export class ClientBoardSummaryComponent extends NonIPBoardSummaryComponent {}
